import axios from 'axios'
import {Message} from 'element-ui'
import store from '@/store'
import {getToken} from '@/utils/auth'

// create an axios instance
const service = axios.create({
  // baseURL: '/CCenterService', // url = base url + request url  //BCSService
  baseURL: '',
  withCredentials: true,
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 300000, // request timeout
  method: 'post'
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['X-Token'] = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    // console.log('request response', response);
    // const {status, data} = response;
    // if (status !== 200) {
    //   const message = '服务器异常，请稍后重试';
    //   Message({
    //     message,
    //     type: 'error',
    //     duration: 5 * 1000
    //   });
    //   return Promise.reject(new Error(message));
    // } else {
    //   return {data: data.dt || data.Tag || data.dts || response, code: data.Result};
    // }
    
    // closeLoading( );
        // console.log('request response', response);
        const {status, data, config} = response;
        if (config.responseType !== 'blob') {
            if (data.Result !== 1) {
                const message = data.Msg ?? '服务器异常，请稍后重试';
                Message({
                    message,
                    type: 'error',
                    duration: 5 * 1000
                });
                return Promise.reject(new Error(message));
            } else {
                return {data: data.dt || data.Tag || data.dts || response, code: data.Result};
            }
        } else {
            return {data: response}
        }

    // const res = response.data;
    // // if the custom code is not 20000, it is judged as an error.
    // if (res.code !== 20000) {
    //   Message({
    //     message: res.message || 'Error',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    //
    //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //     // to re-login
    //     MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
    //       confirmButtonText: 'Re-Login',
    //       cancelButtonText: 'Cancel',
    //       type: 'warning'
    //     }).then(() => {
    //       store.dispatch('user/resetToken').then(() => {
    //         location.reload()
    //       })
    //     })
    //   }
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    //   return res
    // }
  },
  error => {
    console.log('err' + error) // for debug
    // 优先使用后端返回的错误消息（如 GuestSessionHandler 的 401 响应体中的 Msg）
    var errMsg = error.message;
    if (error.response && error.response.data) {
      // 响应可能是 JSON 字符串，也可能是已解析的对象
      var respData = error.response.data;
      if (typeof respData === 'string') {
        try {
          respData = JSON.parse(respData);
        } catch (e) {
          // 保持原样
        }
      }
      if (respData && respData.Msg) {
        errMsg = respData.Msg;
      }
    }
    Message({
      message: errMsg,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
export const baseUrl = 'https://ccapi.langyuntech.com';
// export const baseUrl = 'https://ccapitest.langyuntech.com';
// export const fileBaseUrl = baseUrl + '/UploadFiles/';
export const fileBaseUrl = baseUrl + '/UploadBCSFiles/';